export const SSE_PATHS = {
    APP_EVENTS: '/sse/v1/app-events',
} as const;
